{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "已選擇 {conversationCount} 個對話",
    "NONE": "無",
    "CLEAR_SELECTION": "清除",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {agentName}? | Are you sure you want to assign {n} conversations to {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
    "YES": "是",
    "CANCEL": "取消",
    "SEARCH_INPUT_PLACEHOLDER": "搜尋",
    "ASSIGN_AGENT_TOOLTIP": "指派客服",
    "ASSIGN_TEAM_TOOLTIP": "指派團隊",
    "ASSIGN_SUCCESFUL": "對話指派成功。",
    "ASSIGN_FAILED": "指派對話失敗，請再試一次。",
    "RESOLVE_SUCCESFUL": "對話已成功標記為已解決。",
    "RESOLVE_FAILED": "解決對話失敗，請再試一次。",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "僅選擇了此頁面上可見的對話。",
    "UPDATE": {
      "CHANGE_STATUS": "變更狀態",
      "SNOOZE_UNTIL": "擱置",
      "UPDATE_SUCCESFUL": "對話狀態更新成功。",
      "UPDATE_FAILED": "更新對話失敗，請再試一次。"
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "由於缺少必填屬性，無法解決對話",
      "PARTIAL_SUCCESS": "部分對話因缺少必填屬性而被跳過"
    },
    "LABELS": {
      "ASSIGN_LABELS": "指派標籤",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "指派已選標籤",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "標籤指派成功。",
      "ASSIGN_FAILED": "指派標籤失敗，請再試一次。",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "無",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {teamName}? | Are you sure you want to assign {n} conversations to {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
      "ASSIGN_SUCCESFUL": "團隊指派成功。",
      "ASSIGN_FAILED": "指派團隊失敗，請再試一次。"
    }
  }
}
